module.exports = __webpack_public_path__ + "img/d200809-2.f6ed5318.jpg";